/// <reference path="../../../node_modules/@types/jquery/index.d.ts" />

export interface SelectListItem {
    disabled: boolean;
    group: SelectListGroup;
    selected: boolean;
    value: string;
    text: string;
}

export interface SelectListGroup {
    disabled: boolean;
    name: string;
}

export class Utility {

    public static SendAntiForgery(): any {
        return { "__RequestVerificationToken": $('input[name=__RequestVerificationToken]').val() }
    }

    public static ShowCancelModal(): void {
        $('#CancelModal').data("kendoDialog").open();
    }

    public static OnOpen(): void{
        $("#cancelButton").slideUp();
        $("#submitButton").slideUp();
    }

    public static OnClose(): void{
        $("#cancelButton").slideDown();
        $("#submitButton").slideDown();
    }

    public static RedirectToHomeIndex(): void{
        const baseUrl = window.location.origin;
        window.location.href = `${baseUrl}/Home/Index`;
    }
}